import { reactive } from 'vue';
import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import {
  delete_order_used_record,
  start_order_used_record,
  update_order_used_record_manual_fee,
  send_receipt,
  query_person_to_costom_list,
} from '@/api/mjstore-model';
import { message, notification, Modal } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import modalBox from '@/components/form-modal/modal-tools';
import moment from 'moment';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '手工费',
    style: (record: any) => {
      if (record.manual_fee == 0) {
        if (!record.is_delete && record.is_auto_finish_card != true) {
          return 'color: #f50';
        } else {
          return '';
        }
      } else {
        if (!record.is_delete && record.is_auto_finish_card != true) {
          return 'color: #1da57a';
        } else {
          return '';
        }
      }
    },
    type: 'dropdown',
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const ids: any = [];
      if (record.staff_serve_list && record.staff_serve_list.length > 0) {
        record.staff_serve_list.map((item: any) => {
          ids.push(item.staff_id);
        });
      }
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '手工费',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'staff_ids',
              label: '服务人',
              disabled: false,
              init_model: { shop_id: record.shop_id ? record.shop_id : null },
              placeholder: '请选择服务人',
              datasourceType: 'remote',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'number',
              name: 'manual_fee',
              label: '手工费',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写手工费',
            },
          ],
          rules: {
            manual_fee: [{ required: true, message: '请填写手工费' }],
            staff_ids: [{ required: true, message: '请选择服务人' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
            manual_fee: record.manual_fee,
            staff_ids: ids,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_order_used_record_manual_fee({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '更新成功',
                });
                Object.assign(record, res);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '开始',
    clazz: 'primary',
    type: 'dropdown',
    is_show: (record: any) => {
      return (
        record.is_delete == false &&
        record.card__project_type__p_type != 21 &&
        record.project__project_type__p_type != 20 &&
        record.is_auto_finish_card != true
      );
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '开始时间',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'datepicker',
              name: 'start_datetime',
              label: '开始时间',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              showTime: true,
              placeholder: '请选择开始时间',
            },
            {
              type: 'remoteselect',
              name: 'bed_id',
              label: '床位',
              disabled: false,
              placeholder: '请选择床位',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-bed',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            start_datetime: [{ required: true, message: '请选择开始时间' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
            shop_id: current_shop?.id,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            start_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '更新成功',
                });
                Object.assign(record, res);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '结束',
    clazz: 'primary',
    type: 'dropdown',
    is_show: (record: any) => {
      return (
        record.is_delete == false &&
        record.card__project_type__p_type != 21 &&
        record.project__project_type__p_type != 20 &&
        record.is_auto_finish_card != true
      );
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        component: 'StaffWorkModel',
        obj: record,
        ok: () => {
          return new Promise(resolve => {
            resolve(null);
            event_obj.emit('refresh');
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '退货',
    clazz: 'primary',
    type: 'dropdown',
    is_show: (record: any) => {
      return (
        record.is_delete == false &&
        (record.card__project_type__p_type == 21 || record.project__project_type__p_type == 20) &&
        record.is_auto_finish_card != true
      );
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const modifyModal: any = reactive({
        visible: false,
        component: 'Orderusedrecordmodel',
        obj: {
          org_id: current_org?.id,
          order_used_record_id: record.id,
          order_used_record__num: record.num,
          shop_id: current_shop?.id,
          staff_id: record.staff_id,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
      });

      modifyModal.visible = true;
      modifyModal.ok = () => {
        event_obj.emit('refresh');
      };
      modifyModal.cancel = () => {};
      modalBox(modifyModal);
    },
  },
  {
    name: '作废',
    clazz: 'danger',
    type: 'dropdown',
    is_show: (record: any) => {
      return (
        record.has_out_record == false &&
        record.is_delete == false &&
        record.is_auto_finish_card != true
      );
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '作废',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
            shop_id: current_shop?.id,
            staff_id: record.staff_id,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            delete_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then((res: any) => {
                if (res.show_message) {
                  Modal.warning({
                    title: res.show_message,
                  });
                } else {
                  message.success('作废成功');
                  event_obj.emit('refresh');
                  Object.assign(record, res);
                  resolve(null);
                }
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   type: 'dropdown',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   is_show: (record: any) => {
  //     return !record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送耗单记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'OrderUsedRecord',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {},
  //         });
  //       }
  //     });
  //   },
  // },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  // {
  //   name: '导出',
  //   clazz: 'primary',
  //   cb: (search_model: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY);
  //     const payload: any = {
  //       org_id: current_org?.id,
  //       ...search_model,
  //     };
  //     let params_str = '';
  //     Object.keys(payload).forEach(key => {
  //       if (payload[key] != null && key != 'current' && key != 'pageSize') {
  //         params_str += key + '=' + payload[key] + '&';
  //       }
  //     });
  //     window.open(
  //       '/mjstore/query_order_used_record_list?export=true&' + params_str + new Date().getTime(),
  //       '_blank',
  //     );
  //     message.success('导出耗单成功');
  //   },
  // },
];
